// taken from https://stackoverflow.com/a/13419367/3200478
export const parseQs = (queryString: string) => {
  const query: Record<string, string> = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = (pairs[i] || '').split('=');
    query[decodeURIComponent(pair[0] || '')] = decodeURIComponent(pair[1] || '');
  }
  return query;
};

export const attachQueryStringToUrl = (url: string, params: Record<string, string>) => {
  return Object.keys(params).reduce(
    (newUrl, key, id) => `${newUrl}${id ? '&' : '?'}${key}=${encodeURIComponent(params[key] || '')}`,
    url,
  );
};

export const attachSearchParamsToUrl = (
  urlString: string | undefined | null,
  searchParams: Record<string, string | undefined>,
) => {
  if (!urlString) return undefined;

  const url = new URL(urlString);

  for (const [key, value] of Object.entries(searchParams)) {
    if (value) url.searchParams.set(key, value);
  }

  return url.href;
};

export const isExternalUrl = (url: string | undefined | null) => {
  if (!url) return false;
  return url.startsWith('http');
};
